import { useCallback, useState } from "react";

export function useStepPasswordModalState(onPasswordForgotClicked: () => void): {
	isModalOpened: boolean;
	closeModal: () => void;
	openModal: () => void;
	onModalAccept: () => void;
} {
	const [isModalOpened, setIsModalOpened] = useState(false);
	const closeModal = useCallback((): void => {
		setIsModalOpened(false);
	}, []);
	const openModal = useCallback((): void => {
		setIsModalOpened(true);
	}, []);
	const onModalAccept = useCallback((): void => {
		onPasswordForgotClicked();
		setIsModalOpened(false);
	}, [onPasswordForgotClicked]);
	return { isModalOpened, closeModal, openModal, onModalAccept };
}
